module.exports = __webpack_public_path__ + "c4df14eee0b28bca07a3f28bd7efc7d8.svg";